import React, { memo, useMemo } from 'react';
import { AlertTriangle } from 'lucide-react';
import PropTypes from 'prop-types';
import Button from './ui/Button';
import Header from './ui/Header';
import LtiNavBar from './LtiNavBar';

const MainScreenHeader = memo(({
  userProfile,
  isLtiUser,
  currentView,
  activeSessions,
  plannedSessions,
  completedSessions,
  shouldShowBanner,
  bannerHeight,
  hasSessionErrors,
  onJoinSession,
  onSetCurrentView,
  onCleanupSessions
}) => {
  const isSessionView = currentView === 'session';

  const shouldFixHeader = !isSessionView;
  const headerTopOffset = shouldShowBanner ? bannerHeight : 0;

  const headerButtons = useMemo(() => (
    <div className="flex items-center gap-2">
      {hasSessionErrors && (
        <Button
          variant="danger"
          size="sm"
          onClick={onCleanupSessions}
          title="Bereinige ungültige Session-Daten"
          className="min-h-[36px] px-2 text-xs"
        >
          <AlertTriangle className="h-3 w-3" aria-hidden="true" />
          <span>Fehler beheben</span>
        </Button>
      )}
    </div>
  ), [hasSessionErrors, onCleanupSessions]);

  const currentUser = useMemo(() => ({
    ...userProfile,
    id: String(userProfile.id)
  }), [userProfile]);

  const isLti = isLtiUser || userProfile?.isLtiUser || localStorage.getItem('ltiContextId');

  if (isSessionView) return null;

  return (
    <>
      {/* Spacer: schiebt sticky Header unter das Banner */}
      {shouldShowBanner && !shouldFixHeader && (
        <div style={{ height: `${bannerHeight}px` }} />
      )}
      {isLti ? (
        <LtiNavBar />
      ) : (
        <Header
          currentUser={currentUser}
          activeSessions={activeSessions}
          plannedSessions={plannedSessions}
          completedSessions={completedSessions}
          onJoinSession={onJoinSession}
          setCurrentView={onSetCurrentView}
          rightContent={headerButtons}
          subtitle={userProfile?.schoolName || 'EachOtter App'}
          disableAutoHide={true}
          position={shouldFixHeader ? 'fixed' : 'sticky'}
          topOffset={headerTopOffset}
        />
      )}
    </>
  );
});

MainScreenHeader.displayName = 'MainScreenHeader';

MainScreenHeader.propTypes = {
  userProfile: PropTypes.object.isRequired,
  isLtiUser: PropTypes.bool,
  currentView: PropTypes.string.isRequired,
  activeSessions: PropTypes.array.isRequired,
  plannedSessions: PropTypes.array.isRequired,
  completedSessions: PropTypes.array.isRequired,
  shouldShowBanner: PropTypes.bool.isRequired,
  bannerHeight: PropTypes.number.isRequired,
  hasSessionErrors: PropTypes.bool.isRequired,
  onJoinSession: PropTypes.func.isRequired,
  onSetCurrentView: PropTypes.func.isRequired,
  onCleanupSessions: PropTypes.func.isRequired
};

export default MainScreenHeader;
